module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_c('h2', {
    staticClass: "nobreak"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('table', {
    staticClass: "calibre12",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre13"
  }, [_c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PAGE")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("I")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("April’s Father")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003"
    }
  }, [_vm._v("        11")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("II")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("April’s Son")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004#Page_21"
    }
  }, [_vm._v("        21")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("III")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Cousin Big Sue")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#Page_40"
    }
  }, [_vm._v("         40")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IV")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Julia")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006#Page_52"
    }
  }, [_vm._v("         52")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("V")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Blue Brook")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007#Page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("         57")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VI")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Uncle Bill")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#Page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("         66")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Birth-Night Supper")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#Page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("         73")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VIII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Premises")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#Page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("         84")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IX")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Saturday Afternoon")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#Page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("         89")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("X")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Barnyard")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#Page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        100")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XI")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Hunting ’Possums and Turkeys")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#Page_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        129")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Duck-Hunting")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#Page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        138")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Quilting")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#Page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        159")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIV")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Church")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#Page_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        180")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XV")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Field Work")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#Page_199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        199")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVI")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Plowing")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#Page_203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        203")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Hog-Killing")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#Page_231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        231")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVIII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Joy and April")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#Page_268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        268")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIX")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("At April’s House")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021#Page_287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("        287")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XX")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Seeking")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022#Page_308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("               308")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-156ff48b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0